import { gql } from '@/lib/graphql/gql'

export const BILLING_USAGE_CONTEXT_QUERY = gql`
  query BillingUsageContext($idCompany: String!) {
    company(id: $idCompany) {
      id
      sevallaBilling {
        id
        subscription {
          id
          currentPeriodStart
          currentPeriodEnd
        }
      }
      allApps: apps(offset: 0, limit: 9999) {
        items {
          id
          displayName
        }
      }
      allDatabases: databases(offset: 0, limit: 9999) {
        items {
          id
          displayName
        }
      }
      allEdgeLoadBalancers: edgeLoadBalancers(offset: 0, limit: 9999) {
        items {
          id
          displayName
        }
      }
      allObjectStorages: objectStorages(offset: 0, limit: 9999) {
        items {
          id
          displayName
        }
      }
      allStaticSites: staticSites(offset: 0, limit: 9999) {
        items {
          id
          displayName
        }
      }
      projects(limit: 500) {
        items {
          id
          displayName
          apps {
            id
            displayName
          }
          databases {
            id
            displayName
          }
          edgeLoadBalancers {
            id
            displayName
          }
          objectStorages {
            id
            displayName
          }
          staticSites {
            id
            displayName
          }
        }
      }
    }
  }
`

export const BILLING_DAILY_USAGE_REPORT_QUERY = gql`
  query BillingDailyUsageReport(
    $idCompany: String!
    $startDate: Date
    $endDate: Date
    $hasPermission: Boolean!
  ) {
    company(id: $idCompany) {
      id
      dailyResourceUsageReport(startDate: $startDate, endDate: $endDate)
        @include(if: $hasPermission) {
        periodStart
        periodEnd
        taxPercent
        totalNet
        totalGross
        totalTax
        days {
          date
          totalNet
          totalGross
          totalTax
          services {
            idService
            serviceName
            totalGross
            totalNet
            totalTax
            usageByType {
              type
              totalUsage
              unitPrice
              net
              gross
              tax
            }
          }
        }
      }
    }
  }
`
